import styled from 'styled-components'
import TableButton from './TableButton'

const TableDeleteButton = styled(TableButton).attrs({
  type: 'circle-x',
})``

export default TableDeleteButton
